module.exports = __webpack_public_path__ + "img/nuclei-01.07fe354b.png";